 export const API_URL =
    process.env.BUN_PUBLIC_API_URL || "http://localhost:3001";